
import SuccessPage from "components/Auth/SuccessPage";
import Forgot from "components/Auth/forget";
import Login from "components/Auth/login";
import Reset from "components/Auth/reset";
import SignUp from "components/Auth/signUp";
  
import CenteredButton from "components/Auth/trial-button";

const PublicRoutes = [
  { path: `/gift-signup`, exact: true, name: 'sign-up', component: SignUp },
  { path: `/gift-login`, exact: true, name: 'Login', component: Login },
  { path: `/forgot-password`, name: 'forgot-password', component: Forgot },
  { path: `/reset`, name: 'reset', component: Reset },
  { path: `/success-page`, name: 'success-pag', component: SuccessPage },
  { path: `/check-button`, name: 'check-button', component: CenteredButton },
  // { path: `/skylife`, name: 'check-button', component: SkyLife },







];
export default PublicRoutes;
